<template>
  <v-card class="elevation-12">
    <v-card-title>
      <v-container>
        <v-row   justify="center">
          <v-col cols="12">
            <v-img :src="require('@/assets/logo_dark.png')" alt="logo" width="228px" class="mx-auto"></v-img>
          </v-col>
          <v-col cols="12">
            <h2 class="title text-center font-weight-bold primary--text">
              {{ $t('LoginPage.Form.header') }}
            </h2>
          </v-col>
          <v-col cols="12">
            <h5 class="subtitle-1 text-center">
              {{ $t('LoginPage.Form.subheader') }}
            </h5>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-form>
        <v-text-field
          prepend-icon="alternate_email"
          name="login"
          :label="$t('LoginPage.Form.identifier')"
          type="text"
          v-model="username"
          @keyup.enter="login"
        ></v-text-field>
        <v-text-field
          id="password"
          prepend-icon="lock"
          name="password"
          :label="$t('LoginPage.Form.password')"
          type="password"
          v-model="password"
          @keyup.enter="login"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions class="px-4">
      <v-spacer></v-spacer>
      <span class="body-2 grey--text text--darken-1 mr-4 forgotPassword" @click="forgotPassword">{{ $t('LoginPage.Button.forgotten') }}</span>
      <v-btn color="primary" :loading="loading" @click="login" :disabled="!canSubmit">{{ $t('LoginPage.Button.tologin') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'TheLoginForm',
  data: () => ({
    username: '',
    password: '',
    loading: false
  }),
  computed: {
    canSubmit () {
      return this.username && this.password && !this.loading
    }
  },
  methods: {
    ...mapActions('auth', [
      'performLogin'
    ]),
    async login () {
      if (this.canSubmit) {
        this.loading = true
        try {
          await this.performLogin({username: this.username, password: this.password})
          this.$emit('logged')
        } catch (error) {
          if (error === 'bad credentials') {
            this.$emit('error', this.$t('LoginPage.Error.invalid'))
          } else if (error === 'inactive') {
            this.$emit('error', this.$t('LoginPage.Error.inactive'))
          } else {
            this.$emit('error', this.$t('LoginPage.Error.failed'))
          }
          this.loading = false
          throw error
        }

      }
    },
    forgotPassword () {
      this.$emit('forgotPassword')
    }
  }
}
</script>

<style scoped>
.forgotPassword {
  cursor: pointer;
}
.localeSelector {
  max-width: 50px;
}
</style>
